import { createGlobalStyle } from 'styled-components';

export const GlobalCustomProperties = createGlobalStyle`
  @property --angle {
    syntax: "<angle>";
    inherits: false;
    initial-value: 0deg;
  }
`;
